import {damsFetch} from "../app/damsFetch";

/**
 * Fetches system tags from the publishing-tags endpoint.
 * @returns {Promise<Array>} An array of system tags.
 */
export const getSystemTags = async () => {
    const res = await damsFetch('/publishing-tags', {method: 'GET'});
    return res?.models || [];
};
